import { MEASUREMENT_COLOR, type MeasurementColor, type MeasurementColorKey } from '@constants/measurements';
import { Dialog, DialogContent, DialogTitle, FormControl, InputLabel, MenuItem, Select, type SelectChangeEvent } from '@mui/material';
import { useAppDispatch, useAppSelector } from '@store/hooks';
import { setMeasurementColor, setMeasurementColorModalState } from '@store/reducers/viewerSlice';

const MeasurementColorModal = () => {
  const dispatch = useAppDispatch();
  const { isMeasurementColorModalOpen, measurementColor } = useAppSelector((state) => state.viewer);

  const handleClose = () => dispatch(setMeasurementColorModalState(false));

  const handleColorChange = (event: SelectChangeEvent<MeasurementColor>) => {
    dispatch(setMeasurementColor(event.target.value as MeasurementColor));
  };

  return (
    <Dialog
      open={isMeasurementColorModalOpen}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">Pick Measurement Color</DialogTitle>
      <DialogContent style={{ width: 260 }}>
        <FormControl fullWidth style={{ marginTop: 18 }}>
          <InputLabel id="color-select-label">Color</InputLabel>
          <Select
            labelId="color-select-label"
            id="color-select"
            value={measurementColor}
            label="Color"
            onChange={handleColorChange}
          >
            {Object.keys(MEASUREMENT_COLOR).filter(key => isNaN(Number(key))).map((colorKey) => (
              <MenuItem key={colorKey} value={MEASUREMENT_COLOR[colorKey as MeasurementColorKey]}>
                {colorKey.capitalize()}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </DialogContent>
    </Dialog>
  );
};

export default MeasurementColorModal;
